import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput, FormError, FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Trades } from '@fortem-monorepo/web-sdk'

export const AccruedInterestField = () => {
  const { control } = useFormContext<Trades.BookTradeBody>()

  return (
    <FormField
      name="accrued_interests"
      control={control}
      render={() => (
        <FormItem>
          <div className="flex items-center gap-2">
            <FormLabel>Accrued Interests</FormLabel>
            <FormError />
          </div>
          <ControlledNumberInput
            name="accrued_interests"
            thousandSeparator=","
            allowNegative
            placeholder="Accrued interests (zero allowed)"
          />
        </FormItem>
      )}
    />
  )
}
